import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    sections: [
      {
        icon: 'IDEA',
        header: 'What is the purpose of this app ?',
        content: [
          {
            text: '"Can Answer That ?" is a Quiz Web application. It consists of tons of questions divided into different categories. You can test your knowledge and learn by answering the questions.',
          },
          {
            button: {
              label: 'Home page',
              href: '/home',
            },
          },
        ],
      },
      {
        icon: 'HAND_POINTER',
        header: 'What exactly can you do here ?',
        content: [
          {
            text: 'You can use RANDOMIZER to quickly navigate through all questions in random order.',
            button: {
              label: 'Randomizer',
              href: '/random',
            },
          },
          {
            text: 'QUESTION BROWSER is for browsing through the whole database of questions using filters.',
            button: {
              label: 'Browser',
              href: '/browse',
            },
          },
          {
            text: 'Use CREATOR if you want to add your own questions with answers.',
            button: {
              label: 'Creator',
              href: '/create',
            },
          },
        ],
      },
      {
        icon: 'WRITE',
        header: 'When creating new question ...',
        content: [
          {
            text: '- use only English language',
          },
          {
            text: '- do not use offensive words',
          },
          {
            text: '- do not duplicate data, check for similar questions before creating new one',
          },
        ],
      },
      {
        icon: 'USER',
        header: 'About the author',
        content: [
          {
            text: "My name is Kamil. I'm polish. I've been Software Developer for around 8 years already.",
            button: {
              variant: 'info',
              label: 'My LinkedIn profile',
              href: 'https://www.linkedin.com/in/nogakamil',
              target: '_new',
            },
          },
          {
            text: 'I mainly specially in web development using JavaScript technologies.',
            button: {
              variant: 'info',
              label: 'My GitHub profile',
              href: 'https://github.com/Karmello',
              target: '_new',
            },
          },
        ],
      },
      {
        icon: 'SETTING',
        header: 'Technologies used',
        content: [
          {
            text: "The project is all done using JavaScript technologies. It's Node.js back-end with MongoDB database and React.js on front-end side. I used Heroku platform to host the environments and AWS domain.",
          },
        ],
      },
    ],
  },
}
